import { CommonModule, DOCUMENT, isPlatformBrowser } from '@angular/common';
import { Component, Inject, Input, PLATFORM_ID, Renderer2 } from '@angular/core';
import { SafeHtml, DomSanitizer } from '@angular/platform-browser';
import { SchemaService } from '../../../shared/services/schema.service';
import { MatExpansionModule } from '@angular/material/expansion';
import { SafehtmlPipe } from '../../../shared/pipes/safehtml.pipe';

@Component({
  selector: 'app-faq-page',
  standalone: true,
  imports: [MatExpansionModule, CommonModule, SafehtmlPipe],
  templateUrl: './faq-page.component.html',
  styleUrl: './faq-page.component.scss'
})
export class FaqPageComponent {
  @Input('faqData') faqData: any
  isFirst = true;
  @Input('qaList') qaList: any;

  script:any;
  actualSchemaValue:any;
  structuredData!: SafeHtml;

  constructor(  private _renderer2: Renderer2,
    @Inject(DOCUMENT) private _document: Document,
    private schemaService: SchemaService,
    private sanitizer: DomSanitizer, @Inject(PLATFORM_ID) private platformId: Object) { }

  ngOnInit(): void {
    this.faqData.forEach((ele: { answer: any; question: any; }) => {
      if(ele && (ele.answer || ele.question)){
        this.addFAQSchema(this.faqData)
      }else{}
    })
  }

  async callSchema(){
    this.actualSchemaValue = await this.schemaService.addSchema();
    const jsonString = JSON.stringify(this.actualSchemaValue);
    const safeJson = this.sanitizer.bypassSecurityTrustHtml(jsonString);
    this.script  = this._renderer2.createElement('script');
    this.script.type = `application/ld+json`;
    this.script.text = safeJson as string;
    // this.script.text = JSON.stringify(this.actualSchemaValue);
    this._renderer2.appendChild(this._document.body, this.script);
  }
  addFAQSchema(data: any[]){
    const BreadcrumbList :any = [];
    if(isPlatformBrowser(this.platformId)){
      data?.forEach((item: any) => {
        const listItem = {
          "@type": "Question",
          "name": item?.question,
          "acceptedAnswer": {
            "@type": "Answer",
            "text": item?.answer
          }
        };
        BreadcrumbList.push(listItem);
      });

      let newData ={   "@context": "https://schema.org",
        "@type": "FAQPage",
        "mainEntity": BreadcrumbList
    }
    this.structuredData = this.sanitizer.bypassSecurityTrustHtml(`
    <script type="application/ld+json">
      ${JSON.stringify(newData)}
    </script>
  `);
    }else{}

    // return newData;
  }
  }
